module.exports = __webpack_public_path__ + "img/T4-B-xs_3.69a55307.png";